import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestService } from '@app/core/api/rest.service';
import { KeyValue, KundendatenTrennen, KundendatenZusammenfassen, PayloadBoolean, PayloadKundendatenPersonBeziehung, PayloadPersonResultList } from '@pezi/entities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class RestKundendatenadminService extends RestService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  searchKunde(searchParams: KeyValue<string, any>[]): Observable<PayloadPersonResultList> {
    const params = this.getKeyValueAsQueryParams(searchParams);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadPersonResultList>(
        this.baseUrl + '/kundendatenadmin/person/suche',
        options);
  }
  searchVerbundKunde(searchParams: KeyValue<string, any>[]): Observable<PayloadPersonResultList> {
    const params = this.getKeyValueAsQueryParams(searchParams);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadPersonResultList>(
        this.baseUrl + '/kundendatenadmin/verbund/person/suche',
        options);
  }

  public getKundendatenBeziehungen(persId: string): Observable<PayloadKundendatenPersonBeziehung> {
    return this.http
      .get<PayloadKundendatenPersonBeziehung>(this.baseUrl + `/kundendatenadmin/beziehungen/${persId}`, this.httpOptions);
  }

  public trenneKundendaten(kundendatenTrennen: KundendatenTrennen): Observable<PayloadBoolean> {
    return this.http
      .post<PayloadBoolean>(
        this.baseUrl + `/kundendatenadmin/trennen`,
        kundendatenTrennen,
        this.httpOptions);
  }

  public zusammenfassenKundendaten(kundendatenZusammenfassen: KundendatenZusammenfassen): Observable<PayloadBoolean> {
    return this.http
      .post<PayloadBoolean>(
        this.baseUrl + `/kundendatenadmin/zusammenfassen`,
        kundendatenZusammenfassen,
        this.httpOptions);
  }

  public getKundendatenVerbund(persId: string): Observable<PayloadKundendatenPersonBeziehung> {
    return this.http
      .get<PayloadKundendatenPersonBeziehung>(this.baseUrl + `/kundendatenadmin/verbund/${persId}`, this.httpOptions);
  }

  public removeVerbund(kundendatenTrennen: KundendatenTrennen): Observable<PayloadBoolean> {
    return this.http
      .post<PayloadBoolean>(
        this.baseUrl + `/kundendatenadmin/verbundremove`,
        kundendatenTrennen,
        this.httpOptions);
  }

  public addVerbund(kundendatenZusammenfassen: KundendatenZusammenfassen): Observable<PayloadBoolean> {
    return this.http
      .post<PayloadBoolean>(
        this.baseUrl + `/kundendatenadmin/verbundadd`,
        kundendatenZusammenfassen,
        this.httpOptions);
  }
}
